<template>
  <div class="header row">
    <div class="col col-xs-6 col-sm-6 col-md-6 col-lg-6 mt-3 mb-3">
        <div class="ms-5 mt-2 float-left">
            <img alt="NICE Logo" src="@/assets/img/NICE-CXone-Logo2.png" class="logo-img"/>
        </div>
    </div>
    <div class="col col-xs-6 col-sm-6 col-md-6 col-lg-6 text-end mt-3 mb-3">
      <ul class="list-style-none me-5">
        <li>
          <span class="text-margin-right-4">Hello <span class="user-name">{{$store.getters.username}}</span></span>
          <span class="link" v-on:click="signOutOidc">Log Off</span>
        </li>
        <li>
          <a class="nav-header-link" :href="customerCommunityLink">Go To Community</a>
        </li>
        <li>
          <a class="nav-header-link" :href="munLink" target="_blank">Go To Manage User Notifications</a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
    import { mapGetters, mapActions } from "vuex";
    import enviromentVariable from '../../constants/enviromentVariable';
export default {
  name: "Header",
  computed: {
    ...mapGetters("oidcStore", [
      "oidcIsAuthenticated",
      "oidcAuthenticationIsChecked",
      "oidcUser",
      "oidcIdToken",
      "oidcIdTokenExp"
    ])
  },
  data() {
    return {
        image: "",
        munLink: enviromentVariable.manageUserNotificationUrl,
        customerCommunityLink: enviromentVariable.customerCommunityUrl
    };
  },
  methods: {
    ...mapActions("oidcStore", ["authenticateOidcSilent", "signOutOidc"])
  }
};
</script>